import { render, staticRenderFns } from "./FlopConfigForm.vue?vue&type=template&id=27de23a0&scoped=true&"
import script from "./FlopConfigForm.vue?vue&type=script&lang=js&"
export * from "./FlopConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./FlopConfigForm.vue?vue&type=style&index=0&id=27de23a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27de23a0",
  null
  
)

export default component.exports